import {
  getEmployeeKey,
  getEmployeesKey,
  useGetEmployee,
  useUpdateEmployee,
} from 'api-hooks/employee';
import { Notification, KIND } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import { queryClient } from 'common/repositories/query-client';
import LoadingComponent from 'components/common/loading';
import notification from 'components/common/notification';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import { SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import * as React from 'react';
import { NavigationProps } from 'types';

import EmployeeForm from './components/form';
import { DetailContainer } from './styles';

export type EmployeeViewParams = {
  id: string;
};

export default function EmployeeView(
  props: NavigationProps<NavigationRoutes.EmployeesView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetEmployee({
    id,
  });

  const { mutateAsync, error: mutateError } = useUpdateEmployee();

  const employee = data?.data;

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          {!!mutateError && !!mutateError.message && (
            <Notification
              overrides={{
                Body: { style: { width: 'auto', wordBreak: 'break-all' } },
              }}
              kind={KIND.negative}
              closeable
            >
              {() => mutateError.message}
            </Notification>
          )}
          <SeparatorVertical $margin={8} />
          <EmployeeForm
            {...props}
            employee={employee}
            onSubmit={async (input, form) => {
              const result = await mutateAsync(
                {
                  employeeId: employee?.id!,
                  body: input,
                },
                {
                  onSuccess: async () => {
                    queryClient.refetchQueries(
                      getEmployeeKey({
                        id: employee?.id!,
                      }),
                    );
                    queryClient.refetchQueries([getEmployeesKey()[0]]);
                  },
                },
              );

              form.reset({
                name: result.data.name,
                username: result.data.username,
                roles: result.data.roles.map((role) => role.id),
                address: result.data.address,
                code: result.data.code,
                gender: result.data.gender,
                phone: result.data.phone,
                phone_2: result.data.phone_2,
                commission: result.data.commission,
                commissionType: result.data.commissionType,
              });

              notification.success({ message: result?.message });

              return result.data;
            }}
          />
        </>
      }
    />
  );
}
